import React from 'react';
import { Overlay } from 'vivace-fluent-motion';
import { useDispatch, useSelector } from 'react-redux';
import * as commonActions from '@common/common.action';
import IntlMessage from '../../helpers/intlMessage';
import './fade.styles.css';

function FadeComponent () {
  const loading = useSelector(state => state.commonReducer.showCarregando);
  const closeLoading = useSelector(
    state => state.commonReducer.closeCarregando
  );
  const dispatch = useDispatch();

  const closeModalLoader = () => {
    dispatch(commonActions.showFadeCarregando(false));
    window.stop();
  };

  return (
    <div className={'mv-fade-container' + (loading ? ' visible' : '')}>
      <Overlay
        className='mv-card-load'
        onCancel={closeLoading && closeModalLoader}
        active={loading}
        spinner
        text={<IntlMessage id = "message.loading"/>}      
      ></Overlay>
    </div>
  );
}

export default FadeComponent;



// WEBPACK FOOTER //
// ./src/componentes/fade/fade.component.js